import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalCreateMapeo =({buscar_cis,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({
          id_mapeo_metrica: 0,
          alcance: "ITEM_KEY_LIKE",
          item_key: "",
          comentario: ""
        })

    const reqField=()=>{
        return(
          <p className='reqField-gs'>
            *
          </p>
        )
      }
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    // console.log(iconsActual)
    // console.log(iconsActual.includes("2"))
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    // const dataTechs=useFetch('cassia/tech_devices','','','GET',server)
    // const dataProxies=useFetch('zabbix/proxies','','','GET',server)
    const dataAgents=useFetch('cassia/device_metrics/catalogs/mapeo','','','GET',server)//manda el id 1 para grupos
    const dataValues=useFetch('cassia/device_metrics/catalogs/value_types','','','GET',server)//manda el id 2 para zonas  
    const dataBrands=useFetch('cassia/device_metrics/catalogs/mapeo','','','GET',server)
    const levels=[
           {
               id:1,
               name:"Por Item Key que contiene (LIKE)",
               cassia_criticality_id:1
           },
           {
               id:2,
               name:"Por Item Key Exacta",
               cassia_criticality_id:2
           }
       ]
    const dataAgentsVisible=(!dataAgents.loading?dataAgents.data.data.filter(elemento => elemento.visible === 1):[])
    const [dataModels,setDataModels]=useState({
        data: [],
        loading: true,
        error: null})
    useEffect(()=>{
        if(ManttoData.brand_id!=null){
          search_marcas(ManttoData.brand_id)
        }
        
      },[ManttoData.brand_id])
    const search_marcas = (brand_id) => {
      // setLoadingCis(true)
      setDataModels({
        data: dataModels.data,
        loading: true,
        error: null})
      const fetchDataPost = async () => {
        try {
            const response = await fetch(
              server.url +
                "/api/v1/cassia/host_models/by_brand/"+brand_id,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  accept: "application/json",
                  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
              }
            );
            if (response.ok) {
                const data1 = await response.json();
                // setDataModels(data1);
                setDataModels({
                  data: data1,
                  loading: false,
                  error: null})
                // setCreateCisModalOpen(true)
            } else {
                const data1 = await response.json();
                throw new Error("Error en la solicitud");
            }
        } catch (error) {
          console.error(error);
        }
      };
  
      fetchDataPost();
    };



    function validarIntervalo(valor) {
      const regex = /^\d+(s|m|h)$/;
      return regex.test(valor);
    }
    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }else   if(e.target.name==="metric"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value===""?"":((value)),
                  ['visible_name']:value===""?"":((value)),
                  ['template_name']:value===""?"":((value)),
                  ['item_name']:value===""?"":((value))
              }
              
          })
      }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
     
      if( ManttoData.id_mapeo_metrica==0 || ManttoData.item_key==""  
      ){
          setDisabled(true)
      }else{
          setDisabled(false)
      }
},[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.id
        }

        let  body ={
          id_mapeo_metrica: ManttoData.id_mapeo_metrica,
          alcance: ManttoData.alcance,
          item_key_exacto: (ManttoData.alcance=='ITEM_KEY_EXACT')?ManttoData.item_key:"",
          item_key_like: (ManttoData.alcance=='ITEM_KEY_LIKE')?ManttoData.item_key:"",
          comentario: ManttoData.comentario
        }



        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/device_metrics/mapeo/', {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(body),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             buscar_cis()
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    // var attr_item=''
    const changeOption=(option,index)=>{
        let attr=''
        if(option.filter=='period'){
            attr='id_mapeo_metrica'
             setManttoData((prevState)=>{
            return {
                ...prevState,
                [attr]:option.value===""?0:(parseInt(option.value))
            }
            
        })
        }else if(option.filter=='Severity'){
          
         setManttoData((prevState)=>{
            return {
                ...prevState,
                ['alcance']:option.value==1?'ITEM_KEY_LIKE':'ITEM_KEY_EXACT'
            }
            
        })
        }
        else if(option.filter=='period'){
            attr='agent_type_id'
        }
        else if(option.filter=='trigger'){
            attr='value_type_id'
        }


        // setManttoRelation(option.value)
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)


    function validarTextoMetrica(valor) {
      const regex = /^[a-zA-Z0-9_-]+$/;
      return regex.test(valor); 
    }

    const { id_mapeo_metrica,alcance,item_key,comentario}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['mapeo'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    <div className="user-box-GS "  style={{height:'20%'}}>
                                        {
                                            (dataBrands.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}  opt_de={(id_mapeo_metrica==null)?0:id_mapeo_metrica} origen={'Admin'} data={dataBrands.data.data}   loading={dataBrands.loading}  titulo='period' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tipoMapeo'])}{(id_mapeo_metrica==0)?reqField():''}</label>   
                                    </div>
                                     
                                    <div className="user-box-GS "  style={{height:'20%'}}>
                                        {
                                            
                                            <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}  opt_de={1} origen={'Admin'} data={levels}   loading={false}  titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tipoCoincidencia'])} ({capitalizeFirstLetter(lang[languaje]['alcance'])})</label>   
                                    </div>
                                    
                                    
                                    <div className="user-box-GS"  style={{height:'20%'}}>
                                    <input required name="item_key"  type="text" value={item_key}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{"Item Key  (ej. `icmpping%`)"}{(item_key=="" )?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'20%'}}>
                                    <input required name="comentario"  type="text" value={comentario}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['comentarios'])}</label>
                                        
                                    </div>
                                   
                                    
                                
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateMapeo